import { isEmpty } from 'util';

export const hasAddOnBeenAdded = (addOn, addOnsList) => {
  const filteredList = addOnsList.filter((el) => el?.uuid === addOn?.uuid);
  if (filteredList.length > 0) return false;
  return addOn;
};

export const getCompleteItems = (items) =>
  items
    .filter((item) => {
      if (item.price?.amount && item.price.amount > 0 && item.name) {
        return item;
      }
      return null;
    })
    .filter(Boolean);

const prepareDataForAPI = (items) => {
  const addOnsList = [];
  const customItemsList = [];

  items.forEach((item) => {
    if (item.isCustomItem) {
      customItemsList.push({
        amount: item.price?.amount,
        description: item.name,
      });
    } else if (item.uuid)
      addOnsList.push({ uuid: item.uuid, amount: item.price?.amount });
  });
  return { addOnsList, customItemsList };
};

const shouldAddTip = ({ body, selectedTip, customTip }) => {
  if (!isEmpty(selectedTip) || +customTip) {
    body.appointmentTip =
      +customTip && +customTip !== 0
        ? { amount: +customTip * 100 }
        : { percent: selectedTip.id };
    return body;
  }
  return body;
};

export const getRequestBody = ({
  service,
  appointment,
  completeItems,
  customDiscount,
  selectedTip,
  customTip,
}) => {
  const { addOnsList, customItemsList } = prepareDataForAPI(completeItems);

  const body = {
    service: {
      uuid: service.uuid,
      amount: service.price?.amount,
    },
    addOns: addOnsList,
    customItems: customItemsList,
    promotionCode: appointment.summary?.discount?.price?.amount,
  };

  if (customDiscount.value) {
    const { value, type } = customDiscount;
    body.customDiscount =
      type === '%' ? { percentOff: value } : { amountOff: value * 100 };
  }

  const bodyWithTip = shouldAddTip({ body, selectedTip, customTip });

  return bodyWithTip;
};
